import React from 'react';
import { useTranslation } from 'react-i18next';
import { NameForm } from '../NameForm';
import { BookmarkCollection } from '../../api';
import * as S from './CollectionForm.styled';

interface CollectionFormProps {
  mode?: 'create' | 'edit';
  onSuccess: () => void;
  hasDescription?: boolean;
  collection?: BookmarkCollection;
}

export const CollectionForm = ({
  mode = 'create',
  hasDescription = true,
  collection,
  onSuccess,
}: CollectionFormProps) => {
  const { t } = useTranslation();
  const isCreateMode = mode === 'create';

  return (
    <S.Form data-testid="create-collection-form">
      {isCreateMode && hasDescription && (
        <S.Description>
          {t('bookmark_collections.add_collection_name_description')}
        </S.Description>
      )}
      <NameForm
        noGutters
        mode={mode}
        onSuccess={onSuccess}
        collection={collection}
      />
    </S.Form>
  );
};
